import { apiClient } from '@/services/ApiClient.js'

export default {
  getOrderNotifications(id) {
    return apiClient
      .get('orders/' + id + '/notifications')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  },
  toggleOrderNotification(orderId, notification) {
    return apiClient
      .post('orders/' + orderId + '/notifications', {
        notification_type: notification
      })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
